angular.module("rjmNg.services").factory "triStateCheckbox", [
  () ->

    STATES =
      UNCHECKED: "off"
      INDETERMINATE: "indeterminate"
      CHECKED: "on"

    # Get the STATE for the specified node. (Taking into account the state of
    # its children.)
    getTriStateState = (node, selection) ->
      if node.children?.length > 0
        childStates = node.children.map (child) ->
          getTriStateState(child, selection)

        allChildrenChecked = childStates.every (state) ->
          state is STATES.CHECKED
        allChildrenUnchecked = childStates.every (state) ->
          state is STATES.UNCHECKED

        if allChildrenChecked
          return STATES.CHECKED
        else if allChildrenUnchecked
          return STATES.UNCHECKED
        else
          return STATES.INDETERMINATE

      else
        if selection[node.id]
          return STATES.CHECKED
        else
          return STATES.UNCHECKED

    # Iterate through a node (and its children) and set the ``id``s on the
    # ``selected`` object to the specified value.
    updateSelected = (selection, children, selected) ->
      for child in children
        if child.children?.length > 0
          updateSelected(selection, child.children, selected)
        else
          selection[child.id] = selected

    {
      STATES
      getTriStateState
      updateSelected
    }

]
